module.exports = __webpack_public_path__ + "img/emoji_161.3c0b05f5.png";